import { FormActionButton } from '@workwave-tidal/core/form'

import { useController } from '../../../../hooks/useController'
import { useTexts } from '../../useTexts'

import { form } from '../../../../formState'

export function ReadyFooter() {
  const {
    status: modalStatus,
    close,
    data: { notification },
  } = useController()

  const texts = useTexts()

  const {
    meta: { submitting: formSubmitting, validating },
  } = form.useFormMeta()

  const disabled = validating || formSubmitting || modalStatus === 'submitting'

  return (
    <>
      <FormActionButton
        testId={`${notification}-test-email-modal-cancel`}
        onClick={close}
        size="medium"
        label={texts.cancel}
      />
      <FormActionButton
        testId={`${notification}-test-email-modal-send`}
        disabled={disabled}
        loading={disabled}
        variant="contained"
        type="submit"
        label={texts.send}
      />
    </>
  )
}
